import React, { useEffect, useState } from "react";
import SubVisual from "../../../components/SubVisual";
import * as S from "./styled";
import subVisualBoard from "../../../assets/subVisual/subVisualBoard.webp";
import { useNavigate, useParams } from "react-router-dom";
import { boardLists } from "../../../data/board";
import Icon from "../../../components/Icon";
import Aos from "aos";
import { Helmet } from "react-helmet-async";

const BoardDetail = () => {
  const { id } = useParams();
  const [board, setBoard] = useState<any>({});

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const getBoardById = (id: any) =>
        boardLists.find((board) => board.id === id);

      setBoard(getBoardById(id));
    } else {
      navigate("/board");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      Aos.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);

  const renderingMessage = (message: string) => {
    return message.split("\n").map((line, index) => {
      // URL 감지 정규식
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const parts = line.split(urlRegex);

      return (
        <span key={index}>
          {parts.map((part, i) =>
            urlRegex.test(part) ? (
              <a
                key={i}
                href={part}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "blue", textDecoration: "underline" }}
              >
                {part}
              </a>
            ) : (
              part
            )
          )}
          <br />
        </span>
      );
    });
  };

  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ipdiakorea.com" />
        <meta
          property="og:image"
          content="https://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <S.BoardDetailContainer>
        <SubVisual
          src={subVisualBoard}
          title="협회 활동"
          subTitle="협회 소식"
        />
        {board && (
          <S.BoardDetailWrapper>
            <div className="inner">
              <S.BoardDetailWrap>
                <S.BoardDetailTitleWrap
                  data-aos="fade"
                  data-aos-duration={600}
                  data-aos-easing="linear"
                >
                  <h6>{board.title}</h6>
                  <p>{board.date}</p>
                </S.BoardDetailTitleWrap>
                <S.BoardContentsWrap
                  data-aos="fade"
                  data-aos-duration={800}
                  data-aos-delay={200}
                  data-aos-easing="linear"
                >
                  {board.images && board.images.length > 0 && (
                    <div className="img-wrap">
                      {board.images.map((image: any, index: number) => (
                        <Icon key={index}>
                          <img src={image} alt="img" />
                        </Icon>
                      ))}
                    </div>
                  )}
                  {board.detailText && (
                    <div className="text-wrap">
                      {renderingMessage(board.detailText)}
                    </div>
                  )}
                </S.BoardContentsWrap>
              </S.BoardDetailWrap>
            </div>
            <S.BoardButtonWrap
              data-aos="fade"
              data-aos-duration={600}
              data-aos-delay={400}
              data-aos-easing="linear"
            >
              <p onClick={() => navigate("/board")}>목록으로</p>
            </S.BoardButtonWrap>
          </S.BoardDetailWrapper>
        )}
      </S.BoardDetailContainer>
    </>
  );
};

export default BoardDetail;
